// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___gAWtg","root__heading":"style-module__root__heading___gGiuo","root__title":"style-module__root__title___Uzjx4","root__list":"style-module__root__list___WLaAY"};
    if(module.hot) {
      // 1697460476227
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  